import { Injectable } from '@angular/core';
import { Dispatch } from '@ngxs-labs/dispatch-decorator';

import { Logout } from '@app/auth';

@Injectable()
export class BanService {
  @Dispatch() public logout = (): Logout => new Logout();
}
